import * as React from 'react'

function SvgIconMediaStop(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g id="media-stop" aria-labelledby="t-media-stop d-media-stop">
        <title id="t-media-stop">{'Stop'}</title>
        <desc id="d-media-stop">{'A square'}</desc>
        <path d="M28 32H4c-2.2 0-4-1.8-4-4V4c0-2.2 1.8-4 4-4h24c2.2 0 4 1.8 4 4v24c0 2.2-1.8 4-4 4z" />
      </g>
    </svg>
  )
}

export default SvgIconMediaStop
